import { useEffect } from "react";

import * as Cookies from "es-cookie";

const FLASH_COOKIE = "_flash";
const FLASH_SUCCESS_MESSAGE = "success";

function getFlashCookie(): string | undefined {
    return Cookies.get(FLASH_COOKIE);
}

// Set a flash cookie in the format the backend reads.
function setFlashCookie(message: string, data: string) {
    const fiveMinutesFromNow = new Date();
    fiveMinutesFromNow.setTime(fiveMinutesFromNow.getTime() + 5 * 60 * 1000);
    const content = `${message.length}:${message}${data}`;
    Cookies.set(FLASH_COOKIE, content, { expires: fiveMinutesFromNow });
}

function setFlashSuccessMessage(data: string) {
    setFlashCookie(FLASH_SUCCESS_MESSAGE, data);
}

function setFlashRedirectToCurrentLocation() {
    // Set a flash cookie to trigger a redirect to the current location after login
    const { pathname, search, hash } = window.location;
    const url = pathname + search + hash;
    setFlashSuccessMessage(url);
}

function addHashToFlashCookie(hash: string) {
    if (hash.charAt(0) !== "#") {
        console.error(`${hash} is not a hash`);
        return;
    }
    const flash = getFlashCookie();
    if (flash) {
        const flashUrl = /^7:success(.*)$/.exec(flash);
        if (flashUrl) {
            const url = flashUrl[1];
            if (url.indexOf("#") === -1) {
                setFlashSuccessMessage(url + hash);
            }
        }
    }
}

function getFlashCookiePath() {
    const flashCookie = getFlashCookie();
    if (!flashCookie) {
        return null;
    }

    const flashUrl = /^7:success(.*)$/.exec(flashCookie);
    if (!flashUrl) {
        return null;
    }

    const path = flashUrl[1];

    const url = new URL(path, window.location.origin);
    if (!url.searchParams.has("noBack")) {
        url.searchParams.append("noBack", "");
    }

    return url.pathname + url.search + url.hash;
}

function removeCookie() {
    Cookies.remove(FLASH_COOKIE);
}

function useConsumeFlashCookiePath() {
    useEffect(() => {
        return () => removeCookie();
    }, []);

    return getFlashCookiePath();
}

export {
    getFlashCookie,
    setFlashSuccessMessage,
    setFlashRedirectToCurrentLocation,
    addHashToFlashCookie,
    useConsumeFlashCookiePath,
};
